import './FinalCTA.css';

const FinalCTA = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de painéis de LED.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="final-cta">
      <div className="final-cta__bg"></div>
      <div className="section-container final-cta__container" data-aos="fade-up">
        <h2>Seu próximo projeto merece impacto visual</h2>
        <p>
          Seja para um evento, shopping ou campanha publicitária — fale com nossos
          especialistas e receba um orçamento personalizado em até 24 horas.
        </p>
        <div className="final-cta__actions">
          <button className="button-primary" onClick={handleWhatsAppClick}>
            <i className="fab fa-whatsapp"></i>
            Falar pelo WhatsApp
          </button>
          <a href="#contato" className="button-secondary">
            <i className="fas fa-file-alt"></i>
            Preencher Formulário
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
